// Auto Delivery Policy PDP widget

  window.addEventListener('ReChargeWidget-loaded', () => {
    window.ReChargeWidget.eventService.addEventListener('widget:build', (widget) => {
     $('.rc_widget__option--subsave')
      .on('click', function(event) {
          document.getElementById("comp").style.display="block";
      });
  
     $('.rc_widget__option--onetime')
      .on('click', function(event) {
          document.getElementById("comp").style.display="none";
      }); 
    });
  });
